// src/lib/queryClient.ts — TanStack Query defaults.
// Plan ref: 05-RESEARCH-ui-shell.md §Code Examples §QueryClient defaults.

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
